import { Box } from 'modules/v2';
import { ScrollArea } from 'modules/v2/navigation/ScrollArea';
import { Year } from './Year';
import { YearsList } from '../../styled';
import { deriveYears } from '../../utils';
export function YearPicker() {
    const years = deriveYears({ date: new Date(), total: 100 });
    return (<Box p="sm">
      <ScrollArea>
        <YearsList>
          {years.map((year) => (<Year key={year.toString()} date={year}/>))}
        </YearsList>
      </ScrollArea>
    </Box>);
}
